import * as React from 'react';
const SVGComponent = props => (
  // <svg
  //   id="Layer_1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   xmlnsXlink="http://www.w3.org/1999/xlink"
  //   x="0px"
  //   y="0px"
  //   viewBox="0 0 1920 673.32"
  //   style={{
  //     enableBackground: 'new 0 0 1920 673.32',
  //   }}
  //   xmlSpace="preserve"
  //   {...props}
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1920 673.32"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <g transform="matrix(1, 0, 0, 1, 0, 148)">
      {/* <g> */}
      <g id="GuardUp_Logo_auf_weiss_RGB">
        <g>
          <g transform="translate(318.664768, 484.69981)">
            <g>
              <path
                d="M150.28,12.97c22.08,0,37.65-11.85,37.65-31.27c0-21.2-17.49-26.68-33.94-31.87c-15.71-4.74-19.71-8.15-19.71-14.53 c0-5.93,5.04-10.38,13.64-10.38c10.53,0,16.16,5.48,19.86,13.34l17.19-9.93c-6.97-14.53-20.01-23.27-37.06-23.27 c-17.79,0-34.09,11.27-34.09,30.83c0,19.71,15.41,26.38,31.28,30.98c15.41,4.44,22.38,7.41,22.38,15.11 c0,5.78-4.3,10.97-16.6,10.97c-12.9,0-20.16-6.22-23.86-15.86l-17.49,10.23C115.15,2.75,129.09,12.97,150.28,12.97z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(385.023875, 484.69981)">
            <g>
              <path
                d="M152.24-18.3h55.88c0.45-2.52,0.74-5.04,0.74-7.86c0-21.79-15.57-39.13-37.51-39.13c-23.27,0-39.13,17.05-39.13,39.13 c0,22.09,15.71,39.13,40.61,39.13c14.23,0,25.34-5.78,32.31-15.86l-15.42-8.89c-3.26,4.3-9.19,7.41-16.6,7.41 C163.07-4.37,154.91-8.52,152.24-18.3z M151.95-33.12c2.22-9.49,9.19-14.97,19.42-14.97c8.01,0,16.01,4.3,18.38,14.97H151.95z "
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(449.159652, 484.69981)">
            <g>
              <path
                d="M192.74,12.97c14.53,0,27.13-7.7,33.5-19.27l-16.6-9.49C206.68-9.7,200.3-6,192.59-6c-11.41,0-19.86-8.45-19.86-20.16 c0-11.86,8.45-20.31,19.86-20.31c7.56,0,13.93,3.85,16.9,9.93l16.45-9.64c-6.08-11.41-18.68-19.12-33.2-19.12 c-22.53,0-39.13,17.05-39.13,39.13C153.61-4.07,170.21,12.97,192.74,12.97z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(508.738172, 484.69981)">
            <g>
              <path
                d="M226.24-63.21v40.02c0,12.9-6.97,18.38-16.31,18.38c-8.6,0-14.67-5.19-14.67-15.27v-43.14h-19.12v45.51 c0,19.71,12.31,30.68,28.02,30.68c9.93,0,17.64-3.7,22.09-10.38v8.3h19.12v-74.11H226.24z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(572.874, 484.69981)">
            <g>
              <path
                d="M217.82-50.46v-12.75H198.7V10.9h19.12v-35.43c0-15.56,12.6-20.01,22.53-18.82v-21.34 C231.02-64.69,221.68-60.54,217.82-50.46z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(612.444819, 484.69981)">
            <g>
              <path
                d="M221.38-72.11c6.53,0,11.86-5.34,11.86-11.71c0-6.38-5.33-11.86-11.86-11.86c-6.37,0-11.71,5.48-11.71,11.86 C209.67-77.44,215.01-72.11,221.38-72.11z M211.89,10.9h19.12v-74.11h-19.12V10.9z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(639.899842, 484.69981)">
            <g>
              <path
                d="M263.44-44.83v-18.38h-16.74v-20.75l-19.12,5.78v14.97h-12.9v18.38h12.9V-14c0,20.01,9.04,27.86,35.87,24.9V-6.44 C252.47-5.85,246.69-6,246.69-14v-30.83H263.44z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(683.027596, 484.69981)">
            <g>
              <path
                d="M283.74-63.21l-16.45,49.81l-19.27-49.81h-20.9L257.5,8.53c-3.56,9.93-8.89,14.38-19.42,14.23v17.79 c18.83,1.04,31.43-8.3,39.14-29.65l26.97-74.11H283.74z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(741.383411, 484.69981)" />
        </g>
        <g>
          <g transform="translate(769.17192, 484.69981)">
            <g>
              <path
                d="M366.56-92.86h-21.05l-29.65,49.06l-29.79-49.06h-21.05V10.9h20.45v-67.15l29.2,48.03h2.37l29.2-48.17V10.9h20.31 V-92.86z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(859.762399, 484.69981)">
            <g>
              <path
                d="M350.66-63.21v8.75c-5.34-6.67-13.34-10.82-24.16-10.82c-19.71,0-36.02,17.05-36.02,39.13 c0,22.09,16.31,39.13,36.02,39.13c10.82,0,18.82-4.15,24.16-10.82v8.74h19.12v-74.11H350.66z M330.06-5.26 c-11.71,0-20.46-8.45-20.46-20.9c0-12.45,8.74-20.9,20.46-20.9c11.85,0,20.6,8.45,20.6,20.9 C350.66-13.7,341.91-5.26,330.06-5.26z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(929.344787, 484.69981)">
            <g>
              <path
                d="M373.7-92.86v38.39c-5.33-6.82-13.19-10.82-24.01-10.82c-19.86,0-36.17,17.05-36.17,39.13 c0,22.09,16.3,39.13,36.17,39.13c10.82,0,18.68-4,24.01-10.82v8.74h19.12V-92.86H373.7z M353.25-5.26 c-11.86,0-20.6-8.45-20.6-20.9c0-12.45,8.74-20.9,20.6-20.9c11.71,0,20.45,8.45,20.45,20.9 C373.7-13.7,364.96-5.26,353.25-5.26z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(998.927176, 484.69981)">
            <g>
              <path
                d="M356.88-18.3h55.88c0.45-2.52,0.74-5.04,0.74-7.86c0-21.79-15.57-39.13-37.51-39.13c-23.27,0-39.13,17.05-39.13,39.13 c0,22.09,15.71,39.13,40.61,39.13c14.23,0,25.34-5.78,32.31-15.86l-15.42-8.89c-3.26,4.3-9.19,7.41-16.6,7.41 C367.7-4.37,359.54-8.52,356.88-18.3z M356.58-33.12c2.22-9.49,9.19-14.97,19.42-14.97c8.01,0,16.01,4.3,18.38,14.97H356.58z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(1063.507555, 484.69981)" />
        </g>
        <g>
          <g transform="translate(1091.296064, 484.69981)">
            <g>
              <path
                d="M407.83,12.97c22.08,0,37.65-11.85,37.65-31.27c0-21.2-17.49-26.68-33.94-31.87c-15.71-4.74-19.71-8.15-19.71-14.53 c0-5.93,5.04-10.38,13.64-10.38c10.53,0,16.16,5.48,19.86,13.34l17.19-9.93c-6.97-14.53-20.01-23.27-37.06-23.27 c-17.79,0-34.09,11.27-34.09,30.83c0,19.71,15.41,26.38,31.28,30.98c15.41,4.44,22.38,7.41,22.38,15.11 c0,5.78-4.3,10.97-16.6,10.97c-12.9,0-20.16-6.22-23.86-15.86l-17.49,10.23C372.7,2.75,386.63,12.97,407.83,12.97z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(1156.098811, 484.69981)">
            <g>
              <path
                d="M402.6-72.11c6.53,0,11.86-5.34,11.86-11.71c0-6.38-5.33-11.86-11.86-11.86c-6.37,0-11.71,5.48-11.71,11.86 C390.89-77.44,396.23-72.11,402.6-72.11z M393.11,10.9h19.12v-74.11h-19.12V10.9z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(1183.553834, 484.69981)">
            <g>
              <path
                d="M484.23-65.29c-10.08,0-17.49,4-22.08,10.67c-4.15-6.82-10.97-10.67-20.16-10.67c-9.48,0-16.45,3.7-20.6,9.93v-7.86 h-19.12V10.9h19.12v-41.65c0-11.11,5.78-16.75,13.93-16.75c8.01,0,12.45,5.34,12.45,14.08V10.9h19.12v-41.65 c0-11.11,5.34-16.75,13.79-16.75c8.01,0,12.45,5.34,12.45,14.08V10.9h19.12v-45.65C512.25-53.28,501.13-65.29,484.23-65.29z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(1278.256984, 484.69981)">
            <g>
              <path
                d="M476.97-65.29c-10.82,0-18.68,4-24.02,10.82v-8.75h-19.12V40.55h19.12V2.16c5.34,6.82,13.19,10.82,24.02,10.82 c19.86,0,36.17-17.04,36.17-39.13C513.13-48.24,496.83-65.29,476.97-65.29z M473.41-5.26c-11.71,0-20.46-8.45-20.46-20.9 c0-12.45,8.74-20.9,20.46-20.9c11.85,0,20.6,8.45,20.6,20.9C494.01-13.7,485.26-5.26,473.41-5.26z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(1347.839373, 484.69981)">
            <g>
              <path
                d="M457.02,10.9h19.12V-97.3h-19.12V10.9z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
        <g>
          <g transform="translate(1375.294396, 484.69981)">
            <g>
              <path
                d="M482.33-18.3h55.88c0.45-2.52,0.74-5.04,0.74-7.86c0-21.79-15.57-39.13-37.51-39.13c-23.27,0-39.13,17.05-39.13,39.13 c0,22.09,15.71,39.13,40.61,39.13c14.23,0,25.34-5.78,32.31-15.86l-15.42-8.89c-3.26,4.3-9.19,7.41-16.6,7.41 C493.16-4.37,485-8.52,482.33-18.3z M482.04-33.12c2.22-9.49,9.19-14.97,19.42-14.97c8.01,0,16.01,4.3,18.38,14.97H482.04z"
                style={{
                  fill: 'rgb(0,0,0)',
                  fillRule: 'nonzero',
                }}
              />
            </g>
          </g>
        </g>
      </g>
      {/* </g> */}
    </g>
    <g transform="matrix(1,0,0,1,-314,-366)">
      <g id="GuardUp_Logo_auf_weiss_RGB">
        <g transform="matrix(8.24198,0,0,8.24198,511.825,1186.17)">
          <path
            d="M-13.41-94.45c-1.22,0-2.37,0.48-3.23,1.34c-2.51,2.51-2.96,6.37-1.12,9.39l2.4,3.92l0.49-0.66 c2.9-3.93,7.53-6.28,12.4-6.28h5.61c4.86,0,9.5,2.34,12.39,6.27l0.49,0.66l2.39-3.91c1.85-3.02,1.39-6.88-1.12-9.39 c-0.86-0.86-2.01-1.34-3.23-1.34H-13.41z M-2.61-81.67c-3.53,0-6.85,1.89-8.66,4.92l-1.11,1.81l1.1,1.8 c1.86,3.04,5.23,4.93,8.8,4.93h5.74c3.54,0,6.87-1.89,8.68-4.94l1.1-1.79l-1.1-1.8c-1.86-3.04-5.23-4.93-8.8-4.93H-2.61z  M-17.86-65.99c-1.73,3-1.25,6.76,1.22,9.22c0.86,0.86,2.01,1.34,3.23,1.34h27.47c1.22,0,2.37-0.48,3.23-1.34 c2.5-2.5,2.96-6.36,1.12-9.39l-2.4-3.92l-0.49,0.66c-2.9,3.93-7.53,6.28-12.4,6.28h-5.6c-4.87,0-9.5-2.35-12.4-6.28l-0.49-0.66 L-17.86-65.99L-17.86-65.99z M-13.99-50.36c-2.22-0.03-4.31-0.91-5.88-2.48l-0.52-0.52c-4.07-4.07-4.78-10.56-1.68-15.42 l3.76-6.15l-3.76-6.14c-3.07-5.02-2.31-11.44,1.85-15.61l0.34-0.34c1.6-1.6,3.73-2.48,5.99-2.48h28.43 c2.26,0,4.39,0.88,5.99,2.48l0.52,0.52c4.07,4.07,4.78,10.56,1.68,15.42l-3.76,6.15l3.76,6.14c3.07,5.03,2.31,11.45-1.85,15.61 l-0.34,0.34c-1.6,1.6-3.73,2.48-5.99,2.48L-13.99-50.36L-13.99-50.36z"
            style={{
              fill: 'rgb(255,9,83)',

              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(8.24198,0,0,8.24198,4416.76,915.344)">
          <path
            d="M-277.18-30.96c4.18,0,7.33-3.11,7.33-7.42c0-4.32-3.16-7.42-7.33-7.42c-4.18,0-7.33,3.11-7.33,7.42 C-284.51-34.07-281.35-30.96-277.18-30.96 M-276.39-50.59c6.31,0,11.55,5.34,11.55,12.2c0,6.91-5.24,12.2-11.55,12.2 c-3.62,0-6.36-1.48-8.12-3.9v12.58h-5.01v-32.48h5.01v3.34C-282.75-49.1-280.01-50.59-276.39-50.59"
            style={{
              fill: 'rgb(255,9,83)',

              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(8.24198,0,0,8.24198,3893.66,503.784)">
          <path
            d="M-241.84,23.75c-7.15,0-12.3-4.36-12.3-11.37V-9.33h5.34v21.39c0,3.81,2.18,6.5,6.96,6.5c4.78,0,6.96-2.69,6.96-6.5 V-9.33h5.34v21.72C-229.55,19.39-234.74,23.75-241.84,23.75"
            style={{
              fill: 'rgb(255,9,83)',

              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(8.24198,0,0,8.24198,3370.03,592.653)">
          <path
            d="M-206.47,8.19c4.18,0,7.33-3.11,7.33-7.42c0-4.32-3.16-7.42-7.33-7.42c-4.18,0-7.33,3.11-7.33,7.42 C-213.81,5.08-210.65,8.19-206.47,8.19 M-199.14-20.11h5.01v32.48h-5.01V9.03c-1.76,2.46-4.5,3.94-8.12,3.94 c-6.31,0-11.55-5.34-11.55-12.2c0-6.91,5.24-12.2,11.55-12.2c3.62,0,6.36,1.48,8.12,3.9V-20.11z"
            style={{
              fill: 'rgb(0,0,0)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(8.24198,0,0,8.24198,2991.81,1027.51)">
          <path
            d="M-180.93-59.7c1.39-3.16,4.22-4.32,7.15-4.32v5.43c-3.29-0.23-7.15,1.3-7.15,6.5v11.69h-5.01v-23.2h5.01V-59.7z"
            style={{
              fill: 'rgb(0,0,0)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(8.24198,0,0,8.24198,2603.65,753.999)">
          <path
            d="M-154.71-11.38c4.18,0,7.33-3.11,7.33-7.42c0-4.32-3.16-7.42-7.33-7.42c-4.18,0-7.33,3.11-7.33,7.42 C-162.04-14.49-158.88-11.38-154.71-11.38 M-147.37-30.41h5.01v23.2h-5.01v-3.34c-1.76,2.46-4.5,3.94-8.12,3.94 c-6.31,0-11.55-5.34-11.55-12.2c0-6.91,5.24-12.2,11.55-12.2c3.62,0,6.36,1.48,8.12,3.9V-30.41z"
            style={{
              fill: 'rgb(0,0,0)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(8.24198,0,0,8.24198,2230.67,1118.96)">
          <path
            d="M-129.51-74.69h5.01v23.2h-5.01v-2.97c-1.53,2.41-4.04,3.57-7.19,3.57c-5.2,0-8.91-3.53-8.91-9.56v-14.25h5.01v13.74 c0,3.53,2.04,5.38,5.2,5.38c3.29,0,5.89-1.95,5.89-6.68V-74.69z"
            style={{
              fill: 'rgb(0,0,0)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(8.24198,0,0,8.24198,1884.68,816.124)">
          <path
            d="M-106.14-31.54v2.23c0,8.86-6.4,15.17-15.92,15.17c-10.12,0-17.31-7.52-17.31-16.84c0-9.33,7.29-16.84,17.03-16.84 c6.17,0,11.42,3.11,14.15,7.7l-4.59,2.65c-1.67-3.02-5.29-5.15-9.56-5.15c-6.87,0-11.69,5.06-11.69,11.69 c0,6.54,4.73,11.6,12.02,11.6c5.89,0,9.51-3.06,10.49-7.42h-10.86v-4.78H-106.14z"
            style={{
              fill: 'rgb(0,0,0)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
    </g>
  </svg>
);
export default SVGComponent;
